// extracted by mini-css-extract-plugin
module.exports = {"requestsContainer":"RequestsContainer_requestsContainer__1VDRU","leftContent":"RequestsContainer_leftContent__3hTgT","tabs_container":"RequestsContainer_tabs_container__1WgSE"};